import { INSURANCE_NAME_ID } from '../../Search/components/Filters/Fields/ids';

const fields = {
  dobYear: { id: 'dobYear', label: 'Year' },
  dobMonth: { id: 'dobMonth', label: 'Birthdate: Month' },
  dobDay: { id: 'dobDay', label: 'Day' },
  insuranceCarrier: { id: 'insuranceCarrier', label: 'Insurance Carrier' },
  insuranceType: { id: 'insuranceType', label: 'Insurance Type' },
  memberId: { id: 'memberId', label: 'Member ID' },
  firstName: { id: 'firstName', label: 'First Name' },
  lastName: { id: 'lastName', label: 'Last Name' },
};

const buildInsuranceProfilePostData = (insuranceForm = {}, accountId, insurers = []) => {
  const insurer = insurers.find(insurer => insurer.id === insuranceForm[INSURANCE_NAME_ID]);
  const insurerName = insurer ? insurer.name : '';

  return {
    account_id: accountId,
    marketplace_insurers_id: insuranceForm[INSURANCE_NAME_ID],
    insurer_name: insurerName,
    insurance_type: 'dental',
    card_front_id: insuranceForm.cardFront,
    card_back_id: insuranceForm.cardBack,
  };
};

const buildNewBookingInsuranceData = (
  insuranceForm = {},
  insurers = [],
  userProfileId = null,
  accountId = null
) => {
  const insurer = insurers.find(insurer => insurer.id === insuranceForm[INSURANCE_NAME_ID]);
  const insurerName = insurer ? insurer.name : '';

  return {
    insurerName,
    marketplace_insurers_id: insuranceForm[INSURANCE_NAME_ID],
    insuranceType: 'dental',
    cardFront: insuranceForm.cardFront,
    cardBack: insuranceForm.cardBack,
    userProfileId,
    accountId,
  };
};

export { fields, buildInsuranceProfilePostData, buildNewBookingInsuranceData };
